import Vuex, { Store } from 'vuex'
import { RootState } from './state'
import type { Client } from 'openapi-fetch'
import { paths } from '@bugseq-site/www/src/lib/api/api'
import { createApiModule } from './modules/api'
import { notifications } from './modules/notifications'

export const createStore = (client: Client<paths>): Store<RootState> => new Vuex.Store<RootState>({
  modules: {
    api: createApiModule(client),
    notifications
  }
})
